module.exports = __webpack_public_path__ + "img/microsoft-word.b54f7334.svg";